import { render } from "./AddMeeskond.vue?vue&type=template&id=0b79745a&scoped=true"
import script from "./AddMeeskond.vue?vue&type=script&lang=js"
export * from "./AddMeeskond.vue?vue&type=script&lang=js"

import "./AddMeeskond.vue?vue&type=style&index=0&id=0b79745a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b79745a"]])

export default __exports__